import { render, staticRenderFns } from "./rejectModal.vue?vue&type=template&id=b2e2c25c&scoped=true"
import script from "./rejectModal.vue?vue&type=script&lang=js"
export * from "./rejectModal.vue?vue&type=script&lang=js"
import style0 from "./rejectModal.vue?vue&type=style&index=0&id=b2e2c25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e2c25c",
  null
  
)

export default component.exports